module.exports = __webpack_public_path__ + "static/media/09.dc20b52a.jpg";